import { DRAFT_TOOL_NAME, OPEN_DOCUMENT_TOOL_NAME, SEARCH_TOOL_NAME } from "./tools";
import type { ToolSchema } from "./toolSchema";

// Planner-facing tools that are handled client-side rather than by a BFF endpoint: navigation, RAG
// document search, and free-text drafting. These are concatenated with the generated endpoint
// catalog to form the full tool list advertised to the planner.
export const CLIENT_TOOL_SCHEMAS: ToolSchema[] = [
  {
    name: "navigate",
    description: "Naviger brukeren til en side eller en bestemt enhet (kontrakt/anskaffelse) via id.",
    parameters: {
      type: "object",
      properties: {
        id: { type: "string", description: "Enhetens id fra et tidligere verktøyresultat" },
        route: { type: "string", description: "Eksplisitt rute for oversiktssider" },
      },
    },
  },
  {
    name: SEARCH_TOOL_NAME,
    description:
      "Søk i innholdet i organisasjonens indekserte dokumenter (kontrakter, anskaffelser, vedlegg). " +
      "Treffene navngir dokument og sidetall — bruk dem som kilder i svaret.",
    parameters: {
      type: "object",
      properties: {
        query: { type: "string" },
        scope: {
          type: "string",
          enum: ["page", "organization", "bids"],
          description:
            "«page» søker kun i dokumentene til enheten brukeren ser på; «organization» søker i hele arkivet; " +
            "«bids» søker i innleverte tilbud på anskaffelsen brukeren ser på (f.eks. for å sammenligne tilbudene)",
        },
      },
      required: ["query", "scope"],
    },
  },
  {
    name: OPEN_DOCUMENT_TOOL_NAME,
    description:
      "Legg et dokument klart for nedlasting som et kort under svaret — bruk dette når brukeren ber om å " +
      "åpne eller laste ned et dokument.",
    parameters: {
      type: "object",
      properties: {
        documentId: { type: "string", description: "Dokumentets id fra et tidligere verktøyresultat" },
        name: { type: "string", description: "Dokumentets navn, vises på kortet" },
      },
      required: ["documentId"],
    },
  },
  {
    name: DRAFT_TOOL_NAME,
    description: "Utarbeid et tekstutkast (svar, tildelingsbrev, beskrivelse).",
    parameters: {
      type: "object",
      properties: { kind: { type: "string" }, instructions: { type: "string" } },
      required: ["kind", "instructions"],
    },
  },
];
